export default __webpack_public_path__ + "static/media/img5.16bbfc28.png";